import React, { useEffect, useRef, useState } from 'react';
import './banner.css';
import playIcon from '../../../../assets/images/play-button.png';
import pauseIcon from '../../../../assets/images/pause-circular-button.png';
import muteIcon from '../../../../assets/images/mute.png';
import unmuteIcon from '../../../../assets/images/unmute.png';

const Banner = () => {
  const iframeRef = useRef(null);
  const [isMuted, setIsMuted] = useState(true);
  const [isPlaying, setIsPlaying] = useState(true);
  const [isHovered, setIsHovered] = useState(false);

  useEffect(() => {
    // Simular autoplay e mute inicial
    if (iframeRef.current) {
      // O iframe já está configurado para autoplay via URL
      setIsPlaying(true);
      setIsMuted(true);
    }

    // Listener para eventos do YouTube
    const handleYouTubeMessage = (event) => {
      if (event.origin !== 'https://www.youtube.com') return;

      try {
        const data = JSON.parse(event.data);
        if (data.event === 'video-progress') {
          // Atualiza estado baseado no player do YouTube
          if (data.info && typeof data.info.playerState !== 'undefined') {
            const playerState = data.info.playerState;
            setIsPlaying(playerState === 1); // 1 = playing, 2 = paused
          }
          if (data.info && typeof data.info.muted !== 'undefined') {
            setIsMuted(data.info.muted);
          }
        }
      } catch (error) {
        // Ignora erros de parsing
      }
    };

    window.addEventListener('message', handleYouTubeMessage);

    // Force iframe and mask to full size with scale approach
    const forceVideoSize = () => {
      const iframe = iframeRef.current;
      if (iframe) {
        // Get container dimensions
        const container = iframe.parentElement;
        const containerWidth = container.offsetWidth;
        const containerHeight = container.offsetHeight;

        // Calculate scale to fill container
        const scaleX = containerWidth / 1188; // YouTube player default width
        const scaleY = containerHeight / 668; // YouTube player default height
        const scale = Math.max(scaleX, scaleY, 1.5); // Use larger scale to ensure full coverage

        // Apply styles to iframe with scale
        iframe.style.cssText = `
          position: absolute !important;
          top: 50% !important;
          left: 50% !important;
          width: 1188px !important;
          height: 668px !important;
          z-index: 1 !important;
          border: none !important;
          transform: translate(-50%, -50%) scale(${scale}) !important;
          transform-origin: center center !important;
        `;

        // Apply same scale to video mask with gradient
        const videoMask = container.querySelector('.video-mask');
        if (videoMask) {
          videoMask.style.cssText = `
            position: absolute !important;
            top: 50% !important;
            left: 50% !important;
            width: 1188px !important;
            height: 668px !important;
            z-index: 2 !important;
            background: linear-gradient(to bottom, hsla(151, 83%, 51%, 0.18) 0%, hsla(151, 83%, 51%, 0.18) 70%, transparent 100%) !important;
            pointer-events: none !important;
            transform: translate(-50%, -50%) scale(${scale}) !important;
            transform-origin: center center !important;
          `;
        }

        // Create a clickable area for video controls at the bottom
        let controlsArea = container.querySelector('.video-controls-area');
        if (!controlsArea) {
          controlsArea = document.createElement('div');
          controlsArea.className = 'video-controls-area';
          container.appendChild(controlsArea);
        }

        controlsArea.style.cssText = `
          position: absolute !important;
          bottom: 0 !important;
          left: 50% !important;
          width: 1188px !important;
          height: 100px !important;
          z-index: 15 !important;
          pointer-events: auto !important;
          transform: translateX(-50%) scale(${scale}) !important;
          transform-origin: center bottom !important;
        `;

        // Ensure iframe allows pointer events
        iframe.style.pointerEvents = 'auto';
      }
    };

    // Force size immediately and on load
    forceVideoSize();
    const timer = setInterval(forceVideoSize, 1000);

    return () => {
      clearInterval(timer);
      window.removeEventListener('message', handleYouTubeMessage);
    };
  }, []);

  const toggleMute = () => {
    const iframe = iframeRef.current;
    if (iframe) {
      // Abordagem 1: Tentar via postMessage
      try {
        const command = isMuted ? 'unMute' : 'mute';
        iframe.contentWindow.postMessage(`{"event":"command","func":"${command}","args":""}`, '*');
      } catch (error) {
        console.log('PostMessage falhou:', error);
      }

      // Abordagem 2: Recriar iframe com parâmetro mute diferente
      const currentSrc = iframe.src;
      if (isMuted) {
        // Desmutar: remover mute=1
        iframe.src = currentSrc.replace('mute=1', 'mute=0');
      } else {
        // Mutar: adicionar mute=1
        iframe.src = currentSrc.replace('mute=0', 'mute=1');
      }

      setIsMuted(!isMuted);
    }
  };

  const playVideo = () => {
    const iframe = iframeRef.current;
    if (iframe) {
      // Abordagem 1: Tentar via postMessage
      try {
        iframe.contentWindow.postMessage('{"event":"command","func":"playVideo","args":""}', '*');
      } catch (error) {
        console.log('PostMessage falhou:', error);
      }

      // Abordagem 2: Recriar iframe com autoplay
      const currentSrc = iframe.src;
      if (!currentSrc.includes('autoplay=1')) {
        iframe.src = currentSrc.replace('autoplay=0', 'autoplay=1');
      }

      setIsPlaying(true);
    }
  };

  const pauseVideo = () => {
    const iframe = iframeRef.current;
    if (iframe) {
      // Abordagem 1: Tentar via postMessage
      try {
        iframe.contentWindow.postMessage('{"event":"command","func":"pauseVideo","args":""}', '*');
      } catch (error) {
        console.log('PostMessage falhou:', error);
      }

      // Abordagem 2: Remover autoplay (força pausa)
      const currentSrc = iframe.src;
      iframe.src = currentSrc.replace('autoplay=1', 'autoplay=0');

      setIsPlaying(false);
    }
  };



  return (
    <div className="swiper-banner banner-netflix" style={{
      position: 'relative !important',
      height: '75vh !important',
      width: '100% !important',
      overflow: 'hidden !important',
      minHeight: '75vh !important',
      maxHeight: '75vh !important'
    }}
      onMouseEnter={() => setIsHovered(true)}
      onMouseLeave={() => setIsHovered(false)}
    >
      <div className="swiper-container">
        <div className="swiper-wrapper">
          <div className="swiper-slide" data-index="0">
            <style>
              {`
                /* Banner Netflix Styles */
                .swiper-banner.banner-netflix {
                  position: relative;
                  height: 75vh;
                  width: 100%;
                  overflow: hidden;
                }

                .swiper-banner.banner-netflix .swiper-container {
                  height: 100% !important;
                  width: 100% !important;
                  min-height: 75vh !important;
                }

                .swiper-banner.banner-netflix .swiper-wrapper {
                  height: 100% !important;
                  width: 100% !important;
                  min-height: 75vh !important;
                }

                .swiper-banner.banner-netflix .swiper-slide {
                  position: relative !important;
                  height: 100% !important;
                  width: 100% !important;
                  min-height: 75vh !important;
                }

                /* Video Styles - Force Full Size */
                .video-youtube,
                #player-blGQdQxNI-0,
                iframe[data-id="blGQdQxNI-0"] {
                  position: absolute !important;
                  top: 0 !important;
                  left: 0 !important;
                  width: 100% !important;
                  height: 100% !important;
                  min-width: 100% !important;
                  min-height: 100% !important;
                  max-width: 100% !important;
                  max-height: 100% !important;
                  z-index: 1 !important;
                  object-fit: cover !important;
                  border: none !important;
                  transform: scale(1) !important;
                }

                /* Video Mask */
                .video-mask {
                  position: absolute !important;
                  top: 0 !important;
                  left: 0 !important;
                  width: 100% !important;
                  height: 100% !important;
                  z-index: 2 !important;
                  pointer-events: auto !important;
                }

                /* Banner Content */
                .banner-area {
                  position: absolute !important;
                  top: 50% !important;
                  left: 2rem !important;
                  transform: translateY(-50%) !important;
                  z-index: 3 !important;
                  max-width: 500px !important;
                }

                .banner-21401 .banner-title{
                  color: #ffffff;
                  font-size: 1.5rem;
                  font-weight: bold;
                  margin-bottom: 1rem;
                }
                .banner-21401 .banner-subtitle{
                  color: #ffffff;
                }
                .banner-21401 .banner-cta{
                  color: #ffffff !important;
                  background: #2191d5 !important;
                  padding: 0.75rem 1.5rem;
                  border-radius: 0.25rem;
                  text-decoration: none;
                  display: inline-block;
                  font-weight: bold;
                }
                .banner-21401 .banner-cta:hover{
                  color: #ffffff !important;
                  background: #0173ba !important;
                }

                /* Novos controles de vídeo são criados via inline styles */
              `}
            </style>

            <div className="banner-area banner-21401">
              <div className="banner-logo mb-4">
                <img src="/logo-trading.png" className="" alt="Banner Logo" style={{ width: '550px', height: 'auto', transform: 'scaleY(3.5)' }}/>
              </div>
              <div className="banner-text">
                <div className="banner-title pb-3">
                  ⚠️ OBRIGATÓRIO Entrar no nosso Grupo de Sinais Ao Vivo 🔴
                </div>
              </div>
              <a
                href="https://t.me/trendingbrazil"
                target="_blank"
                className="banner-cta banner-cta-solid mt-4"
                rel="noopener noreferrer"
              >
                ➡️ ENTRAR NO GRUPO DE SINAIS AO VIVO ⬅️
              </a>
            </div>

            <div className="video-mask" style={{
              position: 'absolute',
              top: 0,
              left: 0,
              width: '100%',
              height: '100%',
              zIndex: 2,
              background: 'hsla(151, 83%, 51%, 0.18)',
              pointerEvents: 'none'
            }}></div>

            <iframe
              ref={iframeRef}
              src="https://www.youtube.com/embed/blGQdQxNI-0?enablejsapi=1&controls=0&rel=0&playsinline=1&loop=1&autoplay=1&mute=1&playlist=blGQdQxNI-0"
              className="video-youtube netflix-mute netflix-doLoop"
              id="player-blGQdQxNI-0"
              data-id="blGQdQxNI-0"
              title="Trending Background Video"
              allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; fullscreen"
              allowFullScreen=""
              style={{
                position: 'absolute !important',
                top: '0 !important',
                left: '0 !important',
                width: '100% !important',
                height: '100% !important',
                minWidth: '100% !important',
                minHeight: '100% !important',
                maxWidth: '100% !important',
                maxHeight: '100% !important',
                zIndex: '1 !important',
                border: 'none !important',
                transform: 'scale(1) !important'
              }}
            ></iframe>

            {/* Novos botões de controle criados do zero */}
            {/* Controls with consistent hover opacity */}
            <div style={{ position: 'absolute', bottom: '16px', right: '16px', display: 'flex', gap: '10px', zIndex: 100 }}>
              <button
                onClick={toggleMute}
                style={{
                  width: '44px', height: '44px', borderRadius: '50%',
                  background: 'rgba(0,0,0,0.55)', border: '2px solid rgba(255,255,255,0.65)', color: '#fff',
                  display: 'flex', alignItems: 'center', justifyContent: 'center', cursor: 'pointer',
                  opacity: isHovered ? 1 : 0.35, transition: 'opacity .2s ease, transform .08s ease, background .2s ease, border-color .2s ease'
                }}
                onMouseEnter={(e) => { e.currentTarget.style.transform = 'scale(1.04)'; }}
                onMouseLeave={(e) => { e.currentTarget.style.transform = 'none'; }}
                aria-label={isMuted ? "Unmute" : "Mute"}
              >
                <img 
                  src={isMuted ? muteIcon : unmuteIcon} 
                  alt={isMuted ? "Unmute" : "Mute"}
                  className="control-icon"
                />
              </button>
              <button
                onClick={isPlaying ? pauseVideo : playVideo}
                style={{
                  width: '44px', height: '44px', borderRadius: '50%',
                  background: 'rgba(0,0,0,0.55)', border: '2px solid rgba(255,255,255,0.65)', color: '#fff',
                  display: 'flex', alignItems: 'center', justifyContent: 'center', cursor: 'pointer',
                  opacity: isHovered ? 1 : 0.35, transition: 'opacity .2s ease, transform .08s ease, background .2s ease, border-color .2s ease'
                }}
                onMouseEnter={(e) => { e.currentTarget.style.transform = 'scale(1.04)'; }}
                onMouseLeave={(e) => { e.currentTarget.style.transform = 'none'; }}
                aria-label={isPlaying ? "Pause" : "Play"}
              >
                <img 
                  src={isPlaying ? pauseIcon : playIcon} 
                  alt={isPlaying ? "Pause" : "Play"}
                  className="control-icon"
                />
              </button>
            </div>
          </div>
        </div>
        <div className="swiper-pagination"></div>
      </div>
    </div>
  );
};

export default Banner;
